module.exports = __webpack_public_path__ + "img/video1.ad1ce9bf.png";